import type { InferOutput } from "valibot";

export const reviewSchema = v.object({
  comment_id: v.number(),
  product_id: v.number(),
  author: v.string(),
  date: v.string(),
  rating: v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(5)),
  content: v.string(),
});
export type Review = InferOutput<typeof reviewSchema>;

export const submitReviewSchema = v.omit(reviewSchema, ["comment_id", "author", "date"]);
export type SubmitReview = InferOutput<typeof submitReviewSchema>;
